var _rect, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersonalDocumentsOrange = function SvgPersonalDocumentsOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 72,
    x: 4,
    y: 70,
    fill: "url(#personal-documents-orange_svg__a)",
    rx: 8,
    transform: "rotate(-90 4 70)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 33,
    r: 8.5,
    stroke: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M22.875 42.5h2.25c4.963 0 9.197 3.593 10.004 8.49.246 1.49.37 2.999.371 4.51h-23c.001-1.511.125-3.02.371-4.51a10.139 10.139 0 0 1 10.004-8.49ZM42 32h26M42 40h26M42 48h26"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "personal-documents-orange_svg__a",
    x1: 64.733,
    x2: 3.969,
    y1: 104.887,
    y2: 104.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BE60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BE60",
    stopOpacity: 0.2
  })))));
};
export default SvgPersonalDocumentsOrange;